import { useMutation, useQueryClient } from '@tanstack/react-query'

import type { MicroserviceApprovalRequest } from '../../types/microservices'
import api from '../../api'

const useAcceptMicroservice = (microserviceID: string) => {
	const queryClient = useQueryClient()

	return useMutation({
		mutationFn: (microserviceApproval: MicroserviceApprovalRequest) => {
			return api.microservices.acceptMicroservice(microserviceApproval)
		},
		onSuccess: () => {
			queryClient.invalidateQueries({ queryKey: ['microservices'] })
			queryClient.invalidateQueries({
				queryKey: ['microservices', microserviceID]
			})
		}
	})
}

export default useAcceptMicroservice
